import { configureStore } from "@reduxjs/toolkit";
import transactionReducer from "../features/transaction/transactionSlice";
import filtersReducer from "../features/filters/filterSlice";

export const store = configureStore({
	reducer: {
		transaction: transactionReducer,
		filters: filtersReducer,
	},
});
